import Handlebars from "handlebars/dist/handlebars.js";

$(function () {

    $('.createsaleslinkblock__section').each(function () {
        let $this = $(this),
            $searchassociationinput = $(".search-association input", $this),
            $radiobuttons = $("input[type=radio]", $this),
            $urlinput = $("input[type=url]", $this),
            $copybtn = $("button", $this),
            $messages = $(".copy-message", $this),
            $okmessage = $messages.filter(".copy-message-ok"),
            $errormessage = $messages.filter(".copy-message-error");

        let createUrl = function () {
            var $radiobtn = $radiobuttons.filter(":checked");
            var assocationId = getAssociationId();
            if (assocationId) {
                $urlinput.val($radiobtn.val() + "?a=" + assocationId);
            }
            else {
                $urlinput.val($radiobtn.val());
            }
            
        }

        let getAssociationId = function () {
            return $this.data("associationid");
        }

        let setAssociationId = function (id) {
            $this.data("associationid", id);
        }

        let showCopyMessage = function ($element) {
            $element.fadeIn(1000, function () {
                setTimeout(function () {
                    $element.fadeOut(1000);
                }, 3000);
            });
        }

        let copyToClipboard = function () {
            $messages.hide();
            if ($urlinput.val().indexOf("?a=") > -1) {
                navigator.clipboard.writeText($urlinput.val());
                showCopyMessage($okmessage);
            }
            else {
                showCopyMessage($errormessage);
            }
        }

        $searchassociationinput.on("search searcherror", function () {
            setAssociationId("");
            createUrl();
        });

        $searchassociationinput.on("selected", function (event, item) {
            setAssociationId(item.id.raw);
            createUrl();
        });

        $radiobuttons.change(createUrl);

        $copybtn.click(copyToClipboard);

    })
});